import React from 'react';
import { MapPin, Mail, Phone, Linkedin } from 'lucide-react';

export default function Home({ darkMode, language }) {
  const isRTL = language === 'ar';
  
  const content = {
    fr: {
      tagline: "EXPERT EN",
      mainTitle: "DÉVELOPPEMENT",
      subTitle: "WEB & MOBILE",
      description: "Développeur Full-Stack passionné spécialisé dans la création de solutions web modernes et innovantes. De la conception à la mise en production, je transforme vos idées en applications performantes."
    },
    ar: {
      tagline: "خبير في",
      mainTitle: "التطوير",
      subTitle: "الويب والموبايل",
      description: "مطور Full-Stack متخصص في إنشاء حلول ويب حديثة ومبتكرة. من التصميم إلى الإنتاج، أحول أفكارك إلى تطبيقات قوية وفعالة."
    }
  };

  const t = content[language];

  return (
    <section className="px-4 pt-8 min-h-screen flex items-start">
      <div className="max-w-7xl mx-auto w-full flex flex-col sm:flex-row gap-6 sm:gap-12 items-start">

        {/* TEXT SECTION */}
        <div className={`${isRTL ? 'text-right' : 'text-left'} w-full sm:w-1/2`}>
          <p className={`text-blue-500 font-semibold text-base sm:text-lg mb-2 sm:mb-3 ${isRTL ? 'font-arabic' : ''}`}>
            {t.tagline}
          </p>

          <h1 className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            {t.mainTitle}
          </h1>

          <h2 className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent ${isRTL ? 'font-arabic' : ''}`}>
            {t.subTitle}
          </h2>

          <p className={`text-sm sm:text-base md:text-lg text-gray-400 mb-6 sm:mb-8 max-w-full sm:max-w-xl ${isRTL ? 'font-arabic' : ''}`}>
            {t.description}
          </p>

          <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8 flex-wrap">
            <MapPin size={18} className="text-blue-500" />
            <span className="text-gray-400 text-sm sm:text-base">Casablanca, Morocco</span>
          </div>

          {/* SOCIAL ICONS */}
          <div className="flex items-center gap-3 sm:gap-4 flex-wrap">
            <a href="mailto:raki39174@gmail.com" className={`p-2 sm:p-3 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded-lg hover:bg-blue-500 transition-colors`}>
              <Mail size={18} />
            </a>
            <a href="tel:+212771080256" className={`p-2 sm:p-3 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded-lg hover:bg-blue-500 transition-colors`}>
              <Phone size={18} />
            </a>
            <a href="https://linkedin.com/in/erraki-abdelmajid-6903622a3" target="_blank" rel="noopener noreferrer" className={`p-2 sm:p-3 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded-lg hover:bg-blue-500 transition-colors`}>
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        {/* IMAGE SECTION */}
        <div className="relative w-full sm:w-1/2 flex justify-center items-start mt-4 sm:mt-0">
          <div className="relative w-full max-w-sm sm:max-w-md">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-600/20 rounded-3xl blur-3xl"></div>
            
            <div className={`relative ${darkMode ? 'bg-gray-800' : 'bg-gray-200'} rounded-3xl overflow-hidden border-4 ${darkMode ? 'border-gray-700' : 'border-gray-300'} shadow-2xl`}>
              <img
                src="./images/1701554154076-removebg-preview (1).webp"
                alt="Profile"
                className="w-full h-auto object-cover object-top"
              />
            </div>

            <div className="absolute -top-4 -right-4 w-20 sm:w-24 h-20 sm:h-24 bg-blue-500 rounded-2xl opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-28 sm:w-32 h-28 sm:h-32 bg-purple-600 rounded-2xl opacity-20 animate-pulse"></div>
          </div>
        </div>

      </div>
    </section>
  );
}
